import { render } from "./Index.vue?vue&type=template&id=7bd1cea4"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Auth/Password/Forgot/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7bd1cea4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7bd1cea4', __exports__)) {
    api.reload('7bd1cea4', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=7bd1cea4", () => {
    api.rerender('7bd1cea4', render)
  })

}


export default __exports__